const useVideoTimedHandlers = ({stopTimeHandlers, startTimeHandlers, onTimeUpdate, onLoadedMetadata}) => {
    const {handlePlayWithTiming, handlePauseWithTiming, handleTimeUpdateWithTiming} = stopTimeHandlers;
    const {handleLoadedMetadataWithStart} = startTimeHandlers;

    const handlePlay = () => {
        handlePlayWithTiming();
    };

    const handlePause = () => {
        handlePauseWithTiming();
    };

    const handleTimeUpdate = (event) => {
        handleTimeUpdateWithTiming(event);
        onTimeUpdate?.(event);
    };

    const handleLoadedMetadata = (event) => {
        handleLoadedMetadataWithStart(event);
        onLoadedMetadata?.(event);
    };

    return {handlePlay, handlePause, handleTimeUpdate, handleLoadedMetadata};
};

export default useVideoTimedHandlers;
